import axios from 'axios'
export default {

    methods:
    {
        fetch()
        {
            axios.get(process.env.API_URL + this.url).then(res => {
                this.data = res.data
                this.updateData()
            }).catch(e => {})
        },

        updateData()
        {
            this.$store.commit('GENERAL/UPDATE_TABLE_DATA', { table: this.tableName, data: this.data })
        },

        exportFile()
        {
            this.$excelExport(this.$refs.table.filteredData)
        },

        delModel(obj, name)
        {
            this.$snotify.confirm(this.$t('GENERAL.DELETE_MODEL', { model: name }), this.$t('GENERAL.DELETE'), {
                buttons: [
                    {text: this.$t('GENERAL.YES'), action: (toast) => {
                        this.$snotify.remove(toast.id)
                        this.$api('delete', this.url + `/${obj.id}`, {}, {
                            title: '',
                            body: this.$t('GENERAL.DELETING'),
                            success: this.$t('GENERAL.DELETED'),
                        }).then(() => {
                            this.afterDeleteModel(obj)
                            this.updateData()
                        }).catch((e) => {})
                    }, bold: false},
                    {text: this.$t('GENERAL.NO'), action: (toast) => this.$snotify.remove(toast.id) },
                ]
            })

        },

        afterUpdateModel(obj)
        {
            for(let i = 0; i < this.data.length; ++i)
            {
                if (this.data[i].id == this.model.id)
                {
                    this.data[i] = obj
                    break
                }
            }
        },

        afterDeleteModel(obj)
        {
            for(let i = 0; i < this.data.length; ++i)
            {
                if (this.data[i].id == obj.id)
                {
                    this.data.splice(i, 1)
                    break
                }
            }
        },

        afterAddModel(obj)
        {
            this.data.push(obj)
        },

        newModel()
        {
            this.formEdit = false
            this.model = JSON.parse(JSON.stringify(this.emptyModel))
            this.$refs.form.open()
        },

        updateModel(model)
        {
            this.formEdit = true
            this.model = JSON.parse(JSON.stringify(model))
            this.$refs.form.open()
        },

        closeForm()
        {
            this.$refs.form.close()
        },

        saveForm()
        {
            const url = this.url
            if (this.formEdit)
            {
                return this.$api('put', url + `/${this.model.id}`, this.model, {
                    title: '',
                    body: this.$t('GENERAL.SAVING'),
                    success: this.$t('GENERAL.SAVED'),
                }).then((obj) => {
                    this.closeForm()
                    this.afterUpdateModel(obj)
                    this.updateData()
                }).catch((e) => {})
            } else {
                return this.$api('post', url, this.model, {
                    title: '',
                    body: this.$t('GENERAL.SAVING'),
                    success: this.$t('GENERAL.SAVED'),
                }).then((obj) => {
                    this.closeForm()
                    this.afterAddModel(obj)
                    this.updateData()
                }).catch((e) => {})
            }
        },

        publishForm()
        {
            this.publish(this.model)
        },

        publish(model)
        {
            this.model = JSON.parse(JSON.stringify(model))
            const url = this.url
            this.$api('post', `${url}/${model.id}/publish`, model, {
                title: '',
                body: this.$t('GENERAL.PUBLISHING'),
                success: this.$t('GENERAL.PUBLISHED')
            }).then(obj => {
                this.closeForm()
                this.afterUpdateModel(obj)
                this.updateData()
            })
        },

        unpublishForm()
        {
            this.unpublish(this.model)
        },

        unpublish(model)
        {
            this.model = JSON.parse(JSON.stringify(model))
            const url = this.url
            this.$api('post', `${url}/${model.id}/unpublish`, model, {
                title: '',
                body: this.$t('GENERAL.UNPUBLISHING'),
                success: this.$t('GENERAL.UNPUBLISHED')
            }).then(obj => {
                this.closeForm()
                this.afterUpdateModel(obj)
                this.updateData()
            })
        }
    },

    mounted()
    {
        if (!this.noFetch)
          this.fetch()
    },

    data()
    {
        return {
            tableName: 'tableUnknown',
            formEdit: false,
            model: {},
        }
    },

}



// WEBPACK FOOTER //
// ./src/pages/mixins/adminTable.js